export default __webpack_public_path__ + "71431c25c0fa06495379c9f688f5ecdc.svg";